import api from "../api/api";

class RotaService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/rotas${q}`).then(r => r.data).catch(err => err);
        } else {
            if (page) {
                return await api.get(`/rotas?page=${page}`).then(r => r.data).catch(err => err);
            } else {
                return await api.get(`rotas`).then(r => r.data).catch(err => err);
            }
        }
    }

    async getByUfIniAndUfFim(ufini: string, uffim: string) {
        return await api.get(`/rotas/list/ufs/${ufini}/${uffim}`).then(res => res.data).catch(err => err);
    }

    async get(id: string) {
        return await api.get(`/rotas/${id}`).then(response => response.data).catch(err => err);
    }

    async create(data: any) {
        return await api.post("/rotas", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        return await api.put(`/rotas/${id}`, data).then(response => response.data);
    }

    async delete(id?: string) {
        return await api.delete(`/rotas/${id}`).then(response => response.data).catch(err => err);
    }
}

const rotaService = new RotaService();

export default rotaService;